import { useEffect, useState } from "react"

interface Token {
  token: string
  account_name: string
  form_key: string
}

export function FormTokensPanel() {
  if (import.meta.env.MODE === "production") return null
  return <FormTokensPanelInner />
}

function FormTokensPanelInner() {
  const [collapsed, setCollapsed] = useState(true)
  const [tokens, setTokens] = useState<Token[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    fetch("/dev/form_tokens.json")
      .then((res) => {
        if (!res.ok) throw new Error(`${res.status}`)
        return res.json()
      })
      .then(setTokens)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="fixed right-4 bottom-4 z-50 max-w-sm rounded-lg bg-gray-900/90 text-xs text-gray-200 shadow-lg backdrop-blur">
      <button
        type="button"
        className="flex w-full items-center justify-between px-3 py-2 font-medium"
        onClick={() => setCollapsed(!collapsed)}
      >
        <span>QA Tokens {loading ? "…" : `(${tokens.length})`}</span>
        <span>{collapsed ? "+" : "-"}</span>
      </button>
      {!collapsed && (
        <ul className="max-h-64 space-y-1 overflow-y-auto border-t border-gray-700 px-3 py-2">
          {error && <li className="text-caution-700">Error: {error}</li>}
          {!error &&
            tokens.map((t) => (
              <li key={t.token}>
                <a
                  href={`/forms/checkins/${t.token}`}
                  className="block rounded px-1 py-0.5 hover:bg-gray-700"
                >
                  <span className="font-mono">{t.token}</span>
                  <span className="ml-2 text-gray-400">
                    {t.account_name} &middot; {t.form_key}
                  </span>
                </a>
              </li>
            ))}
          {!error && !loading && tokens.length === 0 && (
            <li className="text-gray-500">No in-progress submissions</li>
          )}
        </ul>
      )}
    </div>
  )
}
